









































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// types
import { Zone } from "@/services/backgrounds/types";
import { Guid } from "guid-typescript";
import { zoneFields } from "@/components/backgrounds/fields/zoneFields";
// validation
import validate from "@/directives/validate";
import { addZoneValidators, removeZoneValidators } from "@/components/backgrounds/validators";

@Component({
    directives: {
        validate
    }
})
export default class BackgroundZones extends Vue {
    @Prop() zones!: Zone[];
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localZones = [] as Zone[];
    fields = zoneFields;
    validators = {};

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
    }

    // Watchers
    @Watch("zones")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localZones = this.zones;
        if (this.localZones.length > 0) {
            this.localZones.forEach(x => {
                addZoneValidators(this.validators, x.id);
            });
        }
    }

    // methods
    addEmptyZone() {
        const zone = {} as Zone;
        zone.id = Guid.create().toString();
        addZoneValidators(this.validators, zone.id);
        this.localZones.push(zone);
    }

    deleteZone(id: string) {
        const item = this.localZones.find(x => x.id === id);
        if (!item) {
            return;
        }
        this.localZones.splice(this.localZones.indexOf(item), 1);
        this.$nextTick(() => {
            removeZoneValidators(this.validators, item.id);
        });
    }

    emitData() {
        // deep copy to avoid binding
        this.$emit("zonesUpdated", JSON.parse(JSON.stringify(this.localZones)));
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "BackgroundZones", state: state });
    }
}
